import { Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { WorkflowStepAction, WorkflowStepConfiguration, WorkflowStepTypes } from 'src/app/modules/core/store/models/workflow.model';
import * as fromUserProfile from 'src/app/modules/core/store/user-profile';
import { cloneDeep } from 'lodash-es';
import { Observable } from 'rxjs';
import { Store } from '@ngrx/store';

@Component({
    selector: 'topo-workflow-step-action-edit',
    templateUrl: './workflow-step-action-edit.component.html',
    styleUrls: ['./workflow-step-action-edit.component.scss'],
    standalone: false
})
export class WorkflowStepActionEdit implements OnInit, OnDestroy {
  _action: WorkflowStepAction;
  _active: boolean;
  isPrimaryAction: boolean;
  label: string;
  showTranslations: boolean;
  hasLanguages$: Observable<boolean>;

  @ViewChild("input") displayNameInput: ElementRef;

  @Input() set isActive(value: boolean) {
    this._active = value;
    if (this._active === true) {
      setTimeout(() => {
        this.displayNameInput?.nativeElement?.focus();
      }, 200);
    }
  }

  @Input() set action(value: WorkflowStepAction) {
    this._action = cloneDeep(value);
    this.label = value.label;
    this.isPrimaryAction = value?.configuration?.primaryAction === true;
    this.showTranslations = false;
    this.hasLanguages$ = this.store.select(fromUserProfile.selectUserHasLanguages);
  }

  @Input() destinationName: string;
  @Input() destinationColorCode: string;
  @Output() save = new EventEmitter<WorkflowStepAction>();
  @Output() cancel = new EventEmitter<WorkflowStepAction>();

  constructor(private store: Store<any>, private translateService: TranslateService) {}

  ngOnInit(): void {}

  ngOnDestroy(): void {}

  primaryActionChecked(checkbox: any): void {
    if (!!!this._action?.configuration) {
      this._action.configuration = {};
    }
    if (!!this._action?.configuration && this._action?.configuration.primaryAction !== undefined) {
      this._action.configuration.primaryAction = !this._action.configuration.primaryAction;
    } else {
      this._action.configuration.primaryAction = true;
    }
    this.isPrimaryAction = this._action?.configuration?.primaryAction === true;
  }

  saveClick(): void {
    this._action.label = this.label;
    this.save.emit(this._action);
  }

  cancelClick(): void {
    this.cancel.emit(this._action);
  }

  translateClick(): void {
    this.showTranslations = true;
  }

  updateTranslations(actions: WorkflowStepAction[]): void {
    this.showTranslations = false;
    if (actions?.length > 0) {
      this._action = actions[0];
    }
  }

  cancelTranslations($event: any): void {
    this.showTranslations = false;
  }
}
